import { useState } from "react";
import {
  useHelpCenterStore,
  translateHelpCenterText,
  getHelpCenterLanguage,
} from "../../../Stores/HelpCenter";
import { useConfigStore } from "../../../Stores/Config";
import { getPasswordGateDefault } from "./HelpCenterPasswordGateTranslations";
import "./HelpCenterPasswordGate.scss";

export function PasswordGate() {
  const [inputValue, setInputValue] = useState("");
  const passwordError = useHelpCenterStore((s) => s.passwordError);
  const passwordLoading = useHelpCenterStore((s) => s.passwordLoading);
  const submitPassword = useHelpCenterStore((s) => s.submitPassword);
  const configStore = useConfigStore();
  const logo = configStore.config?.logo;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!inputValue.trim() || passwordLoading) return;
    submitPassword(inputValue.trim());
  };

  const translate = (key: string) =>
    translateHelpCenterText(
      key,
      key,
      getPasswordGateDefault(key, getHelpCenterLanguage()),
    );

  return (
    <div className="helpcenter-password-gate">
      <div className="helpcenter-password-gate-content">
        {logo && (
          <img
            src={logo}
            alt=""
            className="helpcenter-password-gate-logo"
          />
        )}
        <h2 className="helpcenter-password-gate-title">
          {translate("loginTitle")}
        </h2>
        <form
          className="helpcenter-password-gate-form"
          onSubmit={handleSubmit}
        >
          <div className="helpcenter-password-gate-field">
            <label
              htmlFor="helpcenter-password"
              className="helpcenter-password-gate-label"
            >
              {translate("passwordLabel")}
            </label>
            <input
              id="helpcenter-password"
              type="password"
              autoComplete="current-password"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className="helpcenter-password-gate-input"
              disabled={passwordLoading}
            />
          </div>
          {passwordError && (
            <p className="helpcenter-password-gate-error">
              {translate("errorMessage")}
            </p>
          )}
          <button
            type="submit"
            className="helpcenter-password-gate-button"
            disabled={passwordLoading || !inputValue.trim()}
          >
            {passwordLoading
              ? "..."
              : translate("continueButton")}
          </button>
        </form>
      </div>
    </div>
  );
}
